import { logoComunidad } from '../../../../../../assets';

const Title = () => {
    return (
        <div className="flex items-center md:gap-2 relative group">
          <img
            src={logoComunidad}
            alt="Comunidad Esri"
            className="h-10 w-auto object-contain"
          />
          <h1 className="text-lg md:text-xl font-bold">Portal comunidad Esri</h1>
        </div>
    );
};

export default Title;
